







































































import { Component, Vue } from "vue-property-decorator";
import { State, namespace } from "vuex-class";
import TPPClaimsModule from "@/store/modules/tpp-claims";
import { TPPClaimsState } from "@/models/store/TPPClaimsState";
import { formatDate } from "@/helpers/functions/format-date";

const tppClaims = namespace(TPPClaimsModule.name);

@Component({
  name: "IncidentInfo"
})
export default class IncidentInfo extends Vue {
  // ===== Props ===== //

  // ===== Store ===== //
  @State("tppClaims") private readonly tppClaims!: TPPClaimsState;
  @tppClaims.Action("handleClaimIncidentDate") public handleClaimIncidentDate!: (payload: string) => void;
  @tppClaims.Action("handleClaimLossType") public handleClaimLossType!: (payload: string) => void;
  @tppClaims.Action("handleClaimLawEnforcementName") public handleClaimLawEnforcementName!: (payload: string) => void;
  @tppClaims.Action("handleClaimFiledReport") public handleClaimFiledReport!: (payload: string) => void;

  // ===== Data ===== //

  // ===== Methods ===== //

  // ===== Computed ===== //
  get lossTypes() {
    return this.tppClaims.lossTypesList;
  }

  get selectedTPPClaim() {
    return this.tppClaims.selectedTPPClaim;
  }

  get claimIncidentDate() {
    return this.selectedTPPClaim!.incident_date ? formatDate(this.selectedTPPClaim!.incident_date) : "";
  }
  set claimIncidentDate(newVal: string) {
    this.handleClaimIncidentDate(newVal);
  }

  get claimLossType() {
    return this.selectedTPPClaim!.loss_type;
  }
  set claimLossType(newVal: string) {
    this.handleClaimLossType(newVal);
  }

  get claimLawEnforcementName() {
    return this.selectedTPPClaim!.authority_name;
  }
  set claimLawEnforcementName(newVal: string) {
    this.handleClaimLawEnforcementName(newVal);
  }

  get claimFiledReport() {
    return this.selectedTPPClaim!.authority_filed_report;
  }
  set claimFiledReport(newVal: string) {
    this.handleClaimFiledReport(newVal);
  }

  // ===== Lifecycle ===== //
}
